import { useState } from "react";
import * as yup from 'yup';
import { createDateFromDDMMYYYY, formatDateYYYYMMDD } from "@icarius-utils/date";

const useHandleForm = (data, createCallback, modifyCallback, invalidDataCallback) => {

  const isCreate = !Boolean(data);

  const createInitialData = () => {

    const getInitialFieldData = (fieldName) => {
      if (fieldName === 'type') {
        return isCreate ? 'P' : data[fieldName];
      }

      if (fieldName === 'status') {
        return isCreate ? 'A' : data[fieldName];
      }

      if (fieldName === 'initialDate' || fieldName === 'endDate') {
        return isCreate ? null : createDateFromDDMMYYYY(data[fieldName]);
      }

      return isCreate ? "" : data[fieldName];
    }

    const fieldNames = [
      "code",
      "status",
      "name",
      "initialDate",
      "endDate",
    ];

    return fieldNames.reduce((initialData, fieldName) => {
      return ({
        ...initialData,
        [fieldName]: getInitialFieldData(fieldName)
      })
    }, {});
  }

  const [formData, setFormData] = useState(createInitialData());

  const dataIsValid = async () => {

    const codeRegex = /^[a-zA-Z][a-zA-Z0-9_]*/;
    const nameRegex = /^[a-zA-Z][a-zA-Z0-9ÑÁÉÍÓÚ]*/;

    let schema = yup.object().shape({
      code: yup.string().matches(codeRegex).required(),
      status: yup.string().required(),
      name: yup.string().matches(nameRegex).required(),
      initialDate: yup.date().required(),
      endDate: yup.date().required(),
    });

    return await schema.isValid(formData).then((valid) => valid);
  }

  const submit = async () => {
    if (await dataIsValid()) {
      let dataToSend = {
        ...formData,
        initialDate: formatDateYYYYMMDD(formData.initialDate),
        endDate: formatDateYYYYMMDD(formData.endDate),
      };

      isCreate ? createCallback(dataToSend) : modifyCallback(dataToSend);
      return true;
    } else {
      invalidDataCallback();
      return false;
    }
  }

  const formatValue = (value, fieldName) => {
    if (fieldName === "code") {
      return value.length > 0 ? value.replace(/\s/g, "").toUpperCase() : "";
    }

    return value;
  }

  const setFormValue = (value, fieldName) => {
    if (fieldName === 'initialDate') {
      setFormData({
        ...formData,
        endDate: null,
        [fieldName]: formatValue(value, fieldName),
      });
      return;
    }

    setFormData({
      ...formData,
      [fieldName]: formatValue(value, fieldName)
    })
  }

  return { isCreate, formData, setFormValue, submit };
}

export default useHandleForm;